import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { LazyLoadImage } from 'react-lazy-load-image-component';

class PlaceholderCard extends PureComponent {
  static propTypes = {
    user: PropTypes.shape(),
  };

  static defaultProps = {
    user: {},
  };

  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
    };
  }

  render() {
    return (
      <div class="single-item-grid" style={{ width: '100%', minHeight: 252 }}>
        <div class="image">
          <a>
            <div class="primary-image-placeholder">
            </div>
          </a>
          <div className="cross-badge">
            <div class="logo-placeholder" />
          </div>
          <span className="cross-badge-text"><div class="text-placeholder" /></span>
        </div>
        <div class="content">
          <div class="text-placeholder cat-placeholder" />
        </div>
      </div>
    );
  }
}

export default PlaceholderCard;
